export class Guid {
    public static validator = new RegExp('^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$', 'i');

    private static EMPTY = '00000000-0000-0000-0000-000000000000';

    public static isGuid(guid: string | Guid | undefined): boolean {
        if (guid === undefined) return false;
        const value: string = guid.toString();
        return guid instanceof Guid || Guid.validator.test(value);
    }

    public static create(): Guid {
        return new Guid([Guid.gen(2), Guid.gen(1), Guid.gen(1), Guid.gen(1), Guid.gen(3)].join('-'));
    }

    public static createEmpty(): Guid {
        return new Guid('emptyguid');
    }

    public static parse(guid: string): Guid {
        return new Guid(guid);
    }

    public static raw(): string {
        return [Guid.gen(2), Guid.gen(1), Guid.gen(1), Guid.gen(1), Guid.gen(3)].join('-');
    }

    private static gen(count: number) {
        let out = '';
        for (let i = 0; i < count; i++) {
            // tslint:disable-next-line:no-bitwise
            out += (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return out;
    }

    private readonly value: string;

    private constructor(uuid: string) {
        if (!uuid) {
            throw new TypeError('Invalid argument; `value` has no value.');
        }

        this.value = Guid.EMPTY;

        if (uuid && Guid.isGuid(uuid)) {
            this.value = uuid;
        }
    }

    public equals(other: Guid): boolean {
        return Guid.isGuid(other) && this.value === other.toString();
    }

    public static empty(): Guid {
        return new Guid(Guid.EMPTY);
    }

    public isEmpty(): boolean {
        return this.value === Guid.EMPTY;
    }

    public toString(): string {
        return this.value;
    }

    toShortString(): string {
        return this.toString().replace(/-/g, '').toLowerCase();
    }

    public toJSON(): string {
        return this.toString();
    }
}
